import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-45294da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "body"
}
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row mt-3" }
const _hoisted_12 = {
  key: 0,
  class: "col-6"
}
const _hoisted_13 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_14 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_17 = { style: {"width":"200px"} }
const _hoisted_18 = { style: {"width":"calc((100% - 290px) / 2)"} }
const _hoisted_19 = {
  key: 0,
  style: {"width":"calc((100% - 290px) / 2)"}
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 2,
  class: "text-center mt-3"
}
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isNew)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              localizedKey: "Add garment management",
              text: "Add garment management"
            }))
          : (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              localizedKey: "Edit garment management",
              text: "Edit garment management"
            }))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_form_field, {
                type: "select",
                labelKey: "Garment",
                labelValue: "Garment",
                placeholderKey: "Garment",
                placeholderValue: "Garment",
                list: _ctx.garmentsAvailable,
                modelValue: _ctx.localModel.garment.identifier,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.garment.identifier) = $event)),
                  _ctx.updateProductionPhases
                ],
                readonly: _ctx.isReadOnly
              }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_form_field, {
                type: "text",
                labelKey: "Batch",
                labelValue: "Batch",
                placeholderKey: "Batch",
                placeholderValue: "Batch",
                modelValue: _ctx.localModel.batchCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.batchCode) = $event)),
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.localModel.manageEntireProduct ? 'col-6' : 'col-12')
            }, [
              _createVNode(_component_form_field, {
                type: "select",
                labelKey: "Does the provider manage the entire product?",
                labelValue: "Does the provider manage the entire product?",
                placeholderKey: "Does the provider manage the entire product?",
                placeholderValue: "Does the provider manage the entire product?",
                list: _ctx.yesOrNoSelect,
                modelValue: _ctx.providerManageEntireProduct,
                "onUpdate:modelValue": _ctx.updateManagingProperty,
                readonly: _ctx.isReadOnly
              }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
            ], 2),
            (_ctx.localModel.manageEntireProduct)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_form_field, {
                    type: "number",
                    labelKey: "Final price (€)",
                    labelValue: "Final price (€)",
                    placeholderKey: "Final price (€)",
                    placeholderValue: "Final price (€)",
                    modelValue: _ctx.localModel.finalPrice,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.finalPrice) = $event)),
                    readonly: _ctx.isReadOnly
                  }, null, 8, ["modelValue", "readonly"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.localModel.garment.identifier && _ctx.localModel.manageEntireProduct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.userKnowDetails == true.toString() ? 'col-sm-12' : 'col-sm-6')
                }, [
                  _createVNode(_component_form_field, {
                    type: "select",
                    labelKey: "Do you know all the countries for all steps?",
                    labelValue: "Do you know all the countries for all steps?",
                    placeholderKey: "Do you know all the countries for all steps?",
                    placeholderValue: "Do you know all the countries for all steps?",
                    list: _ctx.yesOrNoSelect,
                    modelValue: _ctx.userKnowDetails,
                    "onUpdate:modelValue": _ctx.useKnowDetailsUpdated,
                    readonly: _ctx.isReadOnly
                  }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
                ], 2),
                (_ctx.userKnowDetails == false.toString())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_form_field, {
                          type: "select-string",
                          labelKey: "Country",
                          labelValue: "Country",
                          placeholderKey: "Country",
                          placeholderValue: "Country",
                          list: _ctx.countriesTexts,
                          modelValue: _ctx.singleCountryForAllProductionPhases,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.singleCountryForAllProductionPhases) = $event)),
                            _ctx.updateCountryForEachPhase
                          ],
                          class: "w-100",
                          readonly: _ctx.isReadOnly
                        }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"]),
                        (_ctx.globalCountryRisk)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["fs_12 fw_700 d-block ms-2 countryRiskColorByType", _ctx.globalCountryRisk])
                            }, _toDisplayString(_ctx.globalCountryRisk), 3))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.userKnowDetails == true.toString() || !_ctx.localModel.manageEntireProduct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localModel.phaseCountryList, (phaseCountry, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex align-items-start justify-content-between",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_localized_text, {
                        class: "fw_700 d-block mb-2 pb-1",
                        localizedKey: "Production phase",
                        text: "Production phase"
                      }),
                      _createElementVNode("span", null, _toDisplayString(phaseCountry.phase), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["fs_12 fw_700 d-block mt-1 countryRiskColorByType", _ctx.localModel.phaseCountryList[index].countryRisk])
                      }, _toDisplayString(_ctx.localModel.phaseCountryList[index].countryRisk), 3)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_form_field, {
                        type: "select-string",
                        labelKey: "Country",
                        labelValue: "Country",
                        placeholderKey: "Country",
                        placeholderValue: "Country",
                        list: _ctx.countriesTexts,
                        modelValue: _ctx.localModel.phaseCountryList[index].country,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.localModel.phaseCountryList[index].country) = $event),
                        onChange: ($event: any) => (_ctx.checkForCountryRiskByIndex(index)),
                        readonly: _ctx.isReadOnly
                      }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "onChange", "readonly"])
                    ]),
                    (!_ctx.localModel.manageEntireProduct)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_form_field, {
                            type: "number",
                            labelKey: "Price (€)",
                            labelValue: "Price (€)",
                            placeholderKey: "Price (€)",
                            placeholderValue: "Price (€)",
                            modelValue: _ctx.localModel.phaseCountryList[index].price,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.localModel.phaseCountryList[index].price) = $event),
                            readonly: _ctx.isReadOnly
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isReadOnly)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-primary text-center",
                          style: {"width":"70px","margin-top":"27px"},
                          onClick: ($event: any) => (_ctx.clear(index))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Clear",
                            text: "Clear"
                          })
                        ], 8, _hoisted_20))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-tertiary",
                  disabled: _ctx.isSaveDisabled,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, [
                  (_ctx.isNew)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 0,
                        localizedKey: "Create",
                        text: "Create"
                      }))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "Edit",
                        text: "Edit"
                      }))
                ], 8, _hoisted_22)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}